export default function Section({ title, children }) {
  return (
    <section className="p-6 max-w-4xl mx-auto">
      <h2 className="text-xl font-bold text-primary mb-4">{title}</h2>
      <div className="text-gray-700">{children}</div>
    </section>
  );
}